import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import AuthStateReducer, { IAuthState } from "./authentication/Reducer";
import POSStateReducer, { IPOSState } from "./pos/Reducer";
import AppConfigReducer, { IAppConfigState } from "./app/Reducer";

export interface IAppState {
  authState: IAuthState;
  posState: IPOSState;
  appConfigState: IAppConfigState;
}

const appReducer = combineReducers({
  authState: AuthStateReducer,
  posState: POSStateReducer,
  appConfigState: AppConfigReducer,
});

const rootReducer = (state: IAppState | undefined, action: any): IAppState => {
  if (action.type === "LOGOUT" || action.type === "RESET_STORE") {
    storage.removeItem("persist:doxaiAccount");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "pos-billing",
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, rootReducer as any);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true,
    }),
  devTools: process.env.NODE_ENV !== "production",
});
export const persistor = persistStore(store);
export default store;
